import statsig from 'statsig-js';
import { STATSIG_CLIENT_KEY } from '../constants/constants';
import { StatsigConfiguration } from '../models/statsigConfiguration';
import {
    ensureSDKIsInitialized,
    getExperimentValueToOverride,
    getOptions,
    getUser,
    shouldInitializeSDK,
} from './utils';

export {
    DeviceInfo,
    StatsigClient,
    StatsigOptions,
    StatsigUser,
} from 'statsig-js';

export const initializeSdk = async (statsigConfig?: StatsigConfiguration) => {
    const { clientKey, deactivateSdk, options, sampleRate, user } =
        statsigConfig || {};

    if (!shouldInitializeSDK(sampleRate, deactivateSdk)) {
        return null;
    }

    await statsig.initialize(
        clientKey || STATSIG_CLIENT_KEY,
        getUser(user),
        getOptions(options),
    );
};

export const updateUser = async (statsigConfig: StatsigConfiguration) => {
    const { user } = statsigConfig || {};

    await ensureSDKIsInitialized(() => statsig.updateUser(getUser(user)));
};

export const getExperiment = (
    experimentName: string,
    paramName: string,
    defaultValue: any,
) => {
    // TODO: EB-188953 Fire GA event
    const valueToOverride = getExperimentValueToOverride(experimentName);

    return (
        valueToOverride ??
        ensureSDKIsInitialized(
            () =>
                statsig
                    .getExperiment(experimentName)
                    .get(paramName, defaultValue),
            defaultValue,
        )
    );
};

export const checkGate = (gateName: string) => {
    // TODO: EB-188953 Fire GA event
    const valueToOverride = getExperimentValueToOverride(gateName);

    return (
        valueToOverride ??
        ensureSDKIsInitialized(() => statsig.checkGate(gateName))
    );
};

export const getConfig = (configName: string) => {
    // TODO: EB-188953 Fire GA event
    return ensureSDKIsInitialized(() => statsig.getConfig(configName));
};

export const logEvent = (
    eventName: string,
    eventValue?: string | number | null,
    eventMetadata?: Record<string, string> | null,
) => {
    // TODO: EB-188957 Validate event name with Heap's conventions
    // (https://eventbrite.atlassian.net/wiki/spaces/DEV/pages/15423275681/How+to+define+Heap+Events+-+Naming+Standard)
    // TODO: EB-188953 Fire GA event
    ensureSDKIsInitialized(() =>
        statsig.logEvent(eventName, eventValue, eventMetadata),
    );
};

export const getLayer = (layerName: string) => {
    // TODO: EB-188953 Fire GA event
    return ensureSDKIsInitialized(() => statsig.getLayer(layerName));
};

export const shutdown = () => {
    ensureSDKIsInitialized(statsig.shutdown);
};
